import './utils/pollyfills';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueQrcodeReader from 'vue-qrcode-reader';
import VCalendar from 'v-calendar';
import Cleave from 'cleave.js';
import App from './App.vue';
import router from './router';
import store from './store';
import ls from './ls';
import Components from './components';
import Toasted from 'vue-toasted';

import globalMix from './utils/mixins';
import { AUTH_STORAGE_NAME } from './consts';

import { googleMaps } from './plugins/gmap-vue';

import './scss/main.scss';

Vue.use(BootstrapVue);
Vue.use(Components);
Vue.use(VueQrcodeReader);
Vue.use(VCalendar);
Vue.mixin(globalMix);
Vue.use(googleMaps);
Vue.config.productionTip = false;
Vue.use(Toasted, 
  { 
    position: "top-right",
    duration: 3000
  })
Vue.directive('cleave', {
  inserted(el, binding) {
    if (el.tagName !== 'INPUT') {
      el = el.querySelector('input');
    }
    if (el.tagName === 'INPUT' && Object.keys(binding.value).length !== 0 && binding.value.constructor === Object) {
      new Cleave(el, binding.value);
    }
  },
});

const authStorage = ls.getItem(AUTH_STORAGE_NAME);

if (authStorage) {
  store.commit('login', JSON.parse(authStorage));
}

// ... Hotjar Tracking Code for DEV BOXOFFICE

(function (h, o, t, j, a, r) {
  h.hj =
    h.hj ||
    function () {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
  h._hjSettings = { hjid: 3806362, hjsv: 6 };
  a = o.getElementsByTagName('head')[0];
  r = o.createElement('script');
  r.async = 1;
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  a.appendChild(r);
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
